module.exports = __webpack_public_path__ + "static/img/zxbjdd.629472b7.png";